export default __webpack_public_path__ + "static/media/order_history.79461491.svg";